import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { isMobile } from 'react-device-detect';

export const CompatibleContainer = memo(({ children, style, ...rest }) => {
  const { styles } = useStyle();
  return (
    <View style={[styles.container, style]}>
      {isMobile ? (
        <View {...rest} style={styles.compactContainer}>
          {children}
        </View>
      ) : (
        <View {...rest} style={styles.expandContainer}>
          {children}
        </View>
      )}
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size, width }) => ({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  expandContainer: {
    flex: 1,
    alignSelf: 'center',
    width: size.previewCompactMaxWidth,
  },
  compactContainer: {
    flex: 1,
  },
}));
